/**
 * setInterval for pollers and clocks that should not run in a background tab.
 *
 * A hidden tab's ticks are skipped (no fetch, no re-render); if any were skipped, `fn` runs once
 * as soon as the tab is visible again so the page is not stale on return. Every open-but-hidden
 * tab used to keep polling the fleet at full rate. Returns the cleanup function.
 */
export function setVisibleInterval(fn: () => void, ms: number): () => void {
  let missed = false;
  const hidden = () => typeof document !== 'undefined' && document.hidden;
  const id = window.setInterval(() => {
    if (hidden()) { missed = true; return; }
    fn();
  }, ms);
  const onVisible = () => {
    if (!hidden() && missed) { missed = false; fn(); }
  };
  if (typeof document !== 'undefined') document.addEventListener('visibilitychange', onVisible);
  return () => {
    window.clearInterval(id);
    if (typeof document !== 'undefined') document.removeEventListener('visibilitychange', onVisible);
  };
}
